import { render, staticRenderFns } from "./IntroducerTransactionCard.vue?vue&type=template&id=1739d2af&scoped=true"
import script from "./IntroducerTransactionCard.vue?vue&type=script&lang=js"
export * from "./IntroducerTransactionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1739d2af",
  null
  
)

export default component.exports